import PackageCustomizerColumn from './PackageCustomizerColumn';

class PackageCustomizerRow {
  columns: PackageCustomizerColumn[];

  id: string;
}

export default PackageCustomizerRow;
